import React, { useRef, useState } from 'react';
import { navigate } from 'gatsby';
import Layout from '../../layout';
import SEO from '../../components/Seo/Seo';
import { FormWrapper } from '../../components/Form/Form.style';

const Lidworden = () => {
  const sending = useRef(false);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async event => {
    event.preventDefault();
    if (sending.current) return;
    const values = Object.fromEntries(new FormData(event.currentTarget));
    sending.current = true;
    setPending(true);
    setError('');
    try {
      const response = await fetch('/api/membership', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
      });
      const result = await response.json();
      if (!response.ok || result.ok !== true) {
        setError(
          result.message ||
            'Uw aanmelding is niet bevestigd. Neem contact op met secretariaat@nederlandseofficierenvereniging.nl voordat u opnieuw verzendt.'
        );
        return;
      }
      await navigate('/lidworden-bedankt/');
    } catch {
      setError(
        'We kunnen uw aanmelding niet bevestigen. Uw gegevens blijven hieronder staan. Neem contact op met secretariaat@nederlandseofficierenvereniging.nl voordat u opnieuw verzendt.'
      );
    } finally {
      sending.current = false;
      setPending(false);
    }
  };

  return (
    <Layout>
      <SEO title="Lid Worden" />
      <FormWrapper className="Lid-worden">
        <iframe
          title="Lid worden video"
          width="100%"
          height="400"
          src="https://www.youtube.com/embed/XT_nmyCaOMw?rel=0&amp;controls=0&amp;showinfo=0"
          frameBorder="0"
          allowFullScreen
        />
        <form
          name="membership"
          method="POST"
          action="/api/membership"
          onSubmit={handleSubmit}
          aria-busy={pending}
        >
          <noscript>
            Schakel JavaScript in om dit formulier te versturen, of neem contact
            op met secretariaat@nederlandseofficierenvereniging.nl.
          </noscript>
          <div hidden aria-hidden="true">
            <label htmlFor="website">Laat dit veld leeg</label>
            <input
              id="website"
              name="website"
              tabIndex={-1}
              autoComplete="off"
            />
          </div>

          <label className="fieldgroup" htmlFor="voorletters">
            Voorletters <span>*</span>
            <input type="text" id="voorletters" name="voorletters" required />
          </label>

          <label className="fieldgroup" htmlFor="tussenvoegsel">
            Tussenvoegsel
            <input type="text" id="tussenvoegsel" name="tussenvoegsel" />
          </label>

          <label className="fieldgroup" htmlFor="achternaam">
            Achternaam <span>*</span>
            <input type="text" id="achternaam" name="achternaam" required />
          </label>

          <label className="fieldgroup" htmlFor="rang">
            Rang <span>*</span>
            <input type="text" id="rang" name="rang" required />
          </label>

          <label className="fieldgroup" htmlFor="koninklijke">
            Krijgsmachtonderdeel <span>*</span>
            <select id="koninklijke" name="koninklijke[]" required>
              <option value="koninklijke_landmacht">
                Koninklijke Landmacht
              </option>
              <option value="koninklijke_luchtmacht">
                Koninklijke Luchtmacht
              </option>
              <option value="koninklijke_marechaussee">
                Koninklijke Marechaussee
              </option>
              <option value="commando_diensten_centra">
                Commando Diensten Centra
              </option>
              <option value="koninklijke_marine">Koninklijke Marine</option>
            </select>
          </label>

          <label className="fieldgroup" htmlFor="wapen/dienstvak">
            Wapen/dienstvak <span>*</span>
            <input
              type="text"
              id="wapen/dienstvak"
              name="wapen/dienstvak"
              required
            />
          </label>

          <label className="fieldgroup" htmlFor="street">
            Straat <span>*</span>
            <input type="text" id="street" name="street" required />
          </label>

          <label className="fieldgroup" htmlFor="city">
            Woonplaats <span>*</span>
            <input type="text" id="city" name="city" required />
          </label>

          <label className="fieldgroup" htmlFor="postcode">
            Postcode <span>*</span>
            <input
              type="text"
              id="postcode"
              name="postcode"
              placeholder="0000 AA"
              required
            />
          </label>

          <label className="fieldgroup" htmlFor="geboortedatum">
            Geboortedatum <span>*</span>
            <input
              type="date"
              id="geboortedatum"
              name="geboortedatum"
              placeholder="09/05/1994"
              required
            />
          </label>

          <label className="fieldgroup" htmlFor="registratienummer">
            Registratienummer <span>*</span>
            <input
              type="text"
              id="registratienummer"
              name="registratienummer"
              required
            />
          </label>

          <label className="fieldgroup" htmlFor="werknemernummer">
            Werknemernummer <span>*</span>
            <small style={{ marginTop: 10, fontSize: 14, width: '100%' }}>
              9 cijfers, bestaand uit het peoplesoftnummer met cijfers ervoor en
              erachter (zie uw weddestrook)
            </small>
            <input
              type="text"
              id="werknemernummer"
              name="werknemernummer"
              inputMode="numeric"
              pattern="[0-9]{9}"
              maxLength={9}
              required
            />
          </label>

          <label className="fieldgroup" htmlFor="telefoonnummer">
            Telefoonnummer <span>*</span>
            <input
              type="tel"
              id="telefoonnummer"
              name="telefoonnummer"
              required
            />
          </label>

          <label className="fieldgroup" htmlFor="email">
            Email <span>*</span>
            <input type="email" id="email" name="email" required />
          </label>

          <label className="fieldgroup" htmlFor="contributiebetaling">
            Contributiebetaling
            <select id="contributiebetaling" name="contributiebetaling[]">
              <option value="nsk">Actief dienenden via NSK</option>
              <option value="abp">Postactieven via ABP</option>
              <option value="incasso">
                Reserve-officieren via automatische incasso
              </option>
            </select>
          </label>

          <label className="fieldgroup" htmlFor="IBAN_nummer">
            IBAN nummer
            <input type="text" id="IBAN_nummer" name="IBAN_nummer" />
          </label>

          <label className="fieldgroup" htmlFor="opmerkingen">
            Opmerkingen
            <textarea id="opmerkingen" name="opmerkingen" cols="30" rows="10" />
          </label>

          <div className="fieldgroup">
            <h4>Uw gegevens</h4>
            <div>
              <p>
                Uw gegevens worden alleen gebruikt voor registratiedoeleinden en
                de verzending van de nieuwsbrief. Ze zullen nooit aan derden
                worden doorgegeven zonder uw toestemming.
              </p>
            </div>
          </div>

          <div className="fieldgroup">
            <h4>De Financiële Dienstverleners</h4>
            <div>
              <p>
                DFD is de verzekeringspartner van de NOV en de NOV-leden. Met
                persoonlijk advies en maatwerkproducten ontzorgt DFD de militair
                en gezinsleden. Mag DFD vrijblijvend contact met u opnemen om te
                bezien of zij iets voor u kunnen betekenen?
              </p>
            </div>
          </div>

          <label className="fieldgroup" htmlFor="DFD">
            DFD
            <select id="DFD" name="DFD[]">
              <option value="Nee">
                Ik wens nu geen gebruik te maken van het DFD aanbod voor een
                adviesgesprek
              </option>
              <option value="Ja">
                DFD mag mij benaderen voor een persoonlijk en vrijblijvend
                adviesgesprek
              </option>
            </select>
          </label>

          {error && <p role="alert">{error}</p>}
          <button className="button primary" type="submit" disabled={pending}>
            {pending ? 'Bezig met verzenden…' : 'Registreer'}
          </button>
        </form>
      </FormWrapper>
    </Layout>
  );
};

export default Lidworden;
